import PropTypes from 'prop-types';
import FacetButtons from '../attributes/buttons/facet_buttons';
import FacetCheckboxes from '../attributes/checkboxes/facet_checkboxes';
import FacetTexts from '../attributes/texts/facet_texts';
import FacetPowerSearch from '../attributes/text_inputs/facet_power_search';
import FacetStandards from '../facets/facet_standards';
import FacetLexileMeasures from '../facets/facet_lexile_measures';
import FacetProviders from '../facets/facet_providers';
import FacetVideoLength from '../facets/facet_video_length';
import FacetVideoTypes from '../facets/facet_video_types';

const FacetPanelBody = ({ context, facets, panel, panelId }) => {
  const facetProps = {
    context,
    facets,
    panelId,
    items: facets[panel.facetContexts[0]],
    showMore: panel.showMore
  };
  switch (panelId) {
    case 'grade_ids':
      return <FacetButtons {...facetProps} />;
    case 'rating':
      return <FacetTexts {...facetProps} />;
    case 'power_search':
      return <FacetPowerSearch {...facetProps} />;
    case 'ccss':
      return <FacetStandards {...facetProps} />;
    case 'lexile_measures':
      return <FacetLexileMeasures {...facetProps} />;
    case 'provider_ids':
      return <FacetProviders {...facetProps} />;
    case 'video_length':
      return <FacetVideoLength {...facetProps} />;
    case 'video_types':
      return <FacetVideoTypes {...facetProps} />;
    default:
      return <FacetCheckboxes {...facetProps} />;
  }
};

FacetPanelBody.propTypes = {
  context: PropTypes.object,
  facets: PropTypes.object,
  panel: PropTypes.object,
  panelId: PropTypes.string,
  type: PropTypes.string
};

export default FacetPanelBody;
